import { ActionGroupTypes, ActionStatusTypes } from "../../../enum/ActionStatusTypes";
import * as logger from "../../../logger";
import { getNodeById } from "../../../nodeSelector";
import * as nodeUtils from "../../../utils/nodeUtils";
import * as systemUtils from "../../../utils/systemUtils";
import { ACTION_PREFIX_FUNCTION } from "./abstract/functionAbstract";
import { getFunctionReferences, processFunctionReferences } from "./helpers/functionHelper";

const _action = `${ACTION_PREFIX_FUNCTION}_copy`;
const _header = `Copy function`;

export const copyFunction = (root, id) => {
  const _payload = copyFunctionLogic(root, id);

  logger.logAction(_action, _payload, ACTION_PREFIX_FUNCTION);

  return { root, info: _payload };
};

//--------------------------------------------------------------------------------

export const copyFunctionLogic = (root, id) => {
  const { data: _node, index: _index } = getNodeById(root, id);
  if (!_node) {
    throw new Error("Function to copy not found");
  }
  const { data: _nodeCopy, idTrack: _idTrack } = nodeUtils.copy(_node, { name: "" });

  const _nodeBackup = systemUtils.createDeepCopy(_node);
  const _references = getFunctionReferences(root, _node);

  addNodeCopy(_nodeCopy, root, _index + 1);

  handleReferences(_references, _idTrack);

  return generatePayload(_nodeBackup, _index, _nodeCopy, _references.description);
};

const addNodeCopy = (nodeCopy, root, index) => {
  nodeUtils.modifyFunctions(root, (e) => e.splice(index, 0, nodeCopy), false);
};

const handleReferences = (references, idTrack) => {
  const funTarget = (e) => {
    nodeUtils.addIdReference(e.dst, idTrack.get(nodeUtils.getID(e.src)));
  };

  processFunctionReferences(references, funTarget);
};

//--------------------------------------------------------------------------------

const generatePayload = (node, index, nodeCopy, uuidReferences) => {
  const _payload = {
    group: ActionGroupTypes.ADD,
    status: ActionStatusTypes.INDIFFERENT,
    action: _action,
    time: systemUtils.getTimestamp(),
    header: _header,
    description: generatePayloadDescription(node),
    node: node,
    uuid: nodeUtils.getUUID(node),
    index: index,
    uuidCopy: nodeUtils.getUUID(nodeCopy),
  };

  return { ..._payload, ...uuidReferences };
};

const generatePayloadDescription = (node) => {

    return `Copy function '${nodeUtils.getName(node)}'.`;
}